import React from "react";

import { GradientDefs } from "../../GradientDefs";

/**
 * @component MoneyStackIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 * @prop {string} [gradient] - Optional CSS linear-gradient string to apply a custom fill.
 * Format: "linear-gradient(<angle>deg, <color1>, <color2>, ...)"
 *
 * @example
 * return (
 * <MoneyStackIcon gradient="linear-gradient(135deg, #4da2ed, #f72222)" />
 * )
 *
 * @example
 * return (
 *   <MoneyStackIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const MoneyStackIcon = React.forwardRef(
  (
    {
      gradient,
      ...props
    }: React.SVGProps<SVGSVGElement> & {
      gradient?: string;
    },
    ref?: React.Ref<SVGSVGElement>
  ) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      data-testid="MoneyStackIcon"
      fill={
        gradient
          ? "url(#icon-gradient)"
          : props?.fill
          ? props.fill
          : "var(--color-theme-600)"
      }
      focusable={false}
      ref={ref}
      {...props}
    >
      <GradientDefs gradient={gradient} />
      <path d="M15 12h1v1h-2v.5h1.5a.5.5 0 0 1 .497.442L16 14v1.5a.5.5 0 0 1-.442.496L15.5 16H15v.5h-1V16h-1v-1h2v-.5h-1.5a.5.5 0 0 1-.497-.442L13 14v-1.5a.5.5 0 0 1 .442-.496L13.5 12h.5v-.5h1z" />
      <path
        fillRule="evenodd"
        d="M20.5 9c.828 0 1.5.56 1.5 1.25v7.5c0 .69-.672 1.25-1.5 1.25h-12c-.828 0-1.5-.56-1.5-1.25v-7.5C7 9.56 7.672 9 8.5 9zm-12 8.75h12v-7.5h-12z"
        clipRule="evenodd"
      />
      <path d="M18 6.5c.828 0 1.5.56 1.5 1.25H6v8.75l-.154-.007C5.09 16.43 4.5 15.897 4.5 15.25v-7.5c0-.69.672-1.25 1.5-1.25z" />
      <path d="M15.5 4c.828 0 1.5.56 1.5 1.25H3.5V14l-.154-.007C2.59 13.93 2 13.397 2 12.75v-7.5C2 4.56 2.672 4 3.5 4z" />
    </svg>
  )
);
MoneyStackIcon.displayName = "MoneyStackIcon";
export default MoneyStackIcon;
